/**
 * Localhost Development Configuration
 * Used when running on localhost:4000
 */

export const localhostConfig = {
  environment: 'localhost',
  hostname: 'localhost',

  api: {
    baseUrl: '/api', // Proxied through setupProxy.js
    firmwareBaseUrl: 'http://localhost:4000/api',
  },

  oauth: {
    clientId: 'provisioning-dev',
    redirectUri: 'http://localhost:4000/auth/callback',
    authUrl: 'https://keycloak.anepanywhere.com/realms/provisioning-anep/protocol/openid-connect/auth',
    tokenUrl: '/oauth/realms/provisioning-anep/protocol/openid-connect/token',
  },

  ui: {
    title: 'ANEP Device Provisioning [LOCAL]',
    logoUrl: '/logo.png',
    companyName: 'ANEP',
    primaryColor: '#215EA1',
  },

  dev: {
    debug: true,
  },
} as const;

export default localhostConfig;
